import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MainRoute from './Main';
import ToastList from './ToastList';
import AppBase from './AppBase';
import NotFound from './NotFound';

const FeatureRoute = () => (
  <Router basename="/">
    <Switch>
      <Route exact path="/:merchantId">
        <AppBase>
          <Switch>
            <Route component={MainRoute} />
          </Switch>
        </AppBase>
      </Route>
      <Route component={NotFound} />
    </Switch>
    <Route component={ToastList} />
  </Router>
);

export default FeatureRoute;
